const CheckBox = ({
    field = '',
    label = '',
    value = false,
    isRequired = true,
    onChange,
    onClickLabel
}) => {

    console.log(value);

    const change = (e) => {
        let event = { target: {} };
        event.target.value = e.target.checked;
        event.target.name = field;
        if (e.target)
            onChange(field, e.target.checked);
    }

    return (
        <>
            <div className="checkbox-g-vsc mt-30 mb-5">
                <div className="checkbox-vsc">
                    <input type="checkbox" checked={value} onChange={change} name={field} id="checkbox-vsc" required={isRequired} />
                    <label htmlFor="checkbox-vsc"></label>
                </div>
                <span className="lbl-checkbox-vsc" onClick={onClickLabel}>
                    {label}
                </span>
            </div>
            <input
                className="input-required"
                value={(value === false) ? '' : value}
                tabIndex={-1}
                autoComplete="off"
                style={{ opacity: 0, height: 0 }}
                required={isRequired}
                title='Debe seleccionar la casilla'
            />
        </>

    );
}

export { CheckBox };